import {
  NotificationContainer,
  // @ts-expect-error: There is no types lib for it. Consider using another library or implement ourselves.
} from 'react-notifications'; // https://www.npmjs.com/package/react-notifications

export default NotificationContainer;
